import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { Vehicle } from '@commons/models/domain/Vehicle';
import {MapService} from "@commons/services/map/map/map.service";

import {PermissionService} from "@shared/services/permission.service";
import {VehicleUIEventsService} from "@layout/vehicle/services/vehicle-uievents.service";
import { VehicleService } from '@commons/services/vehicle/vehicle.service';
import { NewVehiclesHttpService } from '@shared/services-http/new-vehicles-http.service';
import { LanguageService } from '@shared/services/language.service';

@Component({
    selector: 'tk-vehicle-details-tabs',
    styleUrls: ['./vehicle-details-tabs.component.less'],
    templateUrl: './vehicle-details-tabs.component.html'
})
export class VehicleDetailsTabsComponent implements OnInit {

    topPosition?: number;

    @Output()
    public onTabSelected: EventEmitter<string> = new EventEmitter<string>();

    /**
     * pojazd
     */
    @Input('vehicle') public set vehicleData(data: Vehicle) {
        if (data?.Id !== this._vehicle?.Id) {
            this.selectTab('params');
            this.checkBlockerInfo(data.Id);
        }
        this._vehicle = data;
    }
    public _vehicle: Vehicle;

    /**
     * domyslna zakladka
     */
    public tab?: string;
    /**
     * czy użytkownik ma dostęp do zakładki trasy
     */
    public isRoutesEnabled = false;
    public isVisibleBlockTab: boolean;
    public isVisibleSent: boolean;

    /**
    * czy użytkownik ma dostęp do zakładki e-Toll
    */
    public isETollEnabled = false;

    public selectTab(tab: string) {
      this.setCurrentTabNameInUrl(tab, this.tab);
      this.tab = tab;
      this.onTabSelected.emit(this.tab);

      const isRoutesTab = this.tab === 'routes';
      this.vehicleUIEventsService.isRoutesTabSelected$.next(isRoutesTab);
    }

    /**
    * konstruktor
    */
    constructor(
        private $route: ActivatedRoute,
        private location: Location,
        private router: Router,
        private permissionService: PermissionService,
        private vehicleUIEventsService: VehicleUIEventsService,
        private newVehiclesHttpService: NewVehiclesHttpService,
        private languageService: LanguageService,
    ) {
        this.isRoutesEnabled = this.permissionService.hasVehicleRoutes();
        this.isETollEnabled = this.permissionService.hasEToll();
        this.isVisibleSent = this.languageService.isPolishLanguage;
    }

    ngOnInit() {
        const _tab = this.$route.snapshot.queryParamMap.get('tab') || 'params';
        this.selectTab(_tab);
    }

    private setCurrentTabNameInUrl(newTabName: string, oldTabName?: string) {
      const path = this.location.path();
      if (path.indexOf('&tab=') > -1)
        this.location.go(this.location.path().replace(`&tab=${oldTabName}`, `&tab=${newTabName}`));
      else
        this.location.go(`${this.location.path()}&tab=${newTabName}`);
    }

    public setTop(top: number): void {
        this.topPosition = top;
    }

    private checkBlockerInfo(vehicleId: number): void {
        const ifHasPermissionToVisibleBlockedTab = this.permissionService.hasBlockerRead() || this.permissionService.hasBlockerReadWrite();
        if (!ifHasPermissionToVisibleBlockedTab) {
            this.isVisibleBlockTab = false;
            return;
        }
        const blockerInfo = this.newVehiclesHttpService.vehiclesBlockerInfos.get(`${vehicleId}OUT1`) || this.newVehiclesHttpService.vehiclesBlockerInfos.get(`${vehicleId}OUT2`);
        this.isVisibleBlockTab = blockerInfo ? true : false;
    }

}
